import React from "react";
import { Typography, Box, Link, Tooltip } from "@mui/material";
import IndicatorDataGrid from "./IndicatorDataGrid";
import { BoxWrapper } from "../BoxWrapper";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface FSCv2Data {
  fsc_v2_page_url?: string;
  categories?: any[];
  fsc_total_risk?: number;
  indicators?: any[];
  high_risk_levels?: string[];
}

interface FSCv2NationalRiskAssessmentProps {
  fscData: FSCv2Data;
}

export default function FSCv2NationalRiskAssessment({ fscData }: FSCv2NationalRiskAssessmentProps) {
  return (
    <BoxWrapper style={{}}>
      <Tooltip
        title={
          <React.Fragment>
            Comprehensive assessment of social and environmental risks
            associated with sourcing non-certified wood from specific
            countries. Updated every five years. Sources: FSC
            International Document Center and FSC Risk Assessment
            Platform. For more information, see the{" "}
            <Link
              href="/understand-risk"
              target="_blank"
              style={{ color: "#6db2b8" }}
            >
              Understanding Risk section
            </Link>
            .
          </React.Fragment>
        }
        placement="top"
      >
        <Typography textAlign="center" variant="h4">
          FSC National Risk Assessment{" "}
          <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>{" "}
        </Typography>
      </Tooltip>
      <Box
        sx={{ marginBottom: "15px" }}
        display="flex"
        flexDirection="row"
        justifyContent="center"
      >
        <Typography variant="subtitle1">
          {" "}
          Assessment Page:{" "}
          <b>
            {" "}
            {fscData.fsc_v2_page_url ? (
              <Link
                target="_blank"
                sx={{ cursor: "pointer" }}
                href={fscData.fsc_v2_page_url}
              >
                {fscData.fsc_v2_page_url}
              </Link>
            ) : (
              "No Assessment Page Available"
            )}
          </b>
        </Typography>
      </Box>

      <Box>
        <Tooltip
          title={
            <React.Fragment>
              The number of 64 discreet indicators evaluated by FSC National Risk
              Assessments that is determined to have elevated risk associated with
              a specific attribute. Mitigation measures are identified for mitigating
              Non-negligible Risk. Sources: FSC International Document Center and FSC
              Risk Assessment Platform. For more information, see the{" "}
              <Link
                href="/understand-risk"
                target="_blank"
                style={{ color: "#6db2b8" }}
              >
                Understanding Risk section
              </Link>
              .{" "}
            </React.Fragment>
          }
          placement="top"
        >
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Total Non-negligible Risk Indicators
            <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>: {fscData.fsc_total_risk}
          </Typography>
        </Tooltip>
      </Box>

      {fscData.categories?.map((category: any, index: number) => (
        <IndicatorDataGrid
          key={index}
          category={category}
          indicators={fscData.indicators}
          highRiskLevels={fscData.high_risk_levels || []}
        />
      ))}
    </BoxWrapper>
  );
}
